/**
 * ช่องกรอกน้ำหนักต่อชิ้นและคุณสมบัติเหล็ก (D-165, M14-009)
 *
 * ใช้ร่วมกันในหน้าสร้างและหน้าแก้ไข — ควบคุมจากภายนอก (value/onChange) ตัวเลขเป็นข้อความ
 * ตลอดทาง ไม่ผ่าน `Number` กฎ "ครบหรือว่างทั้งชุด" ตรวจที่ `steelProblems()` ตอนกดบันทึก
 */

import { EMPTY_STEEL_TEXTS, STEEL_LABELS, type SteelTexts } from './productView';
import { InfoHint } from '../components/InfoHint';
import {
  PRODUCT_MATERIAL_FORMS,
  PRODUCT_STEEL_FIELDS,
  type ProductSteelField,
} from '../../lib/products/types';

export interface ProductSteelFieldsProps {
  readonly value: SteelTexts;
  readonly onChange: (field: ProductSteelField, text: string) => void;
  readonly idPrefix: string;
}

export function ProductSteelFields({ value, onChange, idPrefix }: ProductSteelFieldsProps) {
  const texts = { ...EMPTY_STEEL_TEXTS, ...value };
  return (
    <fieldset className="cap-field" data-testid={`${idPrefix}-steel`}>
      <legend className="cap-field__label">
        น้ำหนักและคุณสมบัติเหล็ก{' '}
        <InfoHint
          label="เกี่ยวกับน้ำหนักและคุณสมบัติเหล็ก"
          text="น้ำหนักต่อชิ้นกรอกเดี่ยว ๆ ได้ ส่วนข้อมูลเหล็ก (เกรด รูปทรง ความหนา ความกว้าง) ต้องกรอกครบทั้งชุดหรือเว้นว่างทั้งชุด; แผ่น (SHEET) ต้องมีความยาว ม้วน (COIL) ไม่มีความยาว — ระบบ Store ใช้ค่านี้คำนวณวัตถุดิบ"
        />
      </legend>
      <div className="cap-form__grid">
        {PRODUCT_STEEL_FIELDS.map((field) => (
          <label className="cap-field" key={field}>
            <span className="cap-field__label">{STEEL_LABELS[field]}</span>
            {field === 'material_form' ? (
              <select
                className="cap-input"
                name={field}
                data-testid={`${idPrefix}-${field}`}
                value={texts[field]}
                onChange={(event) => onChange(field, event.target.value)}
              >
                <option value="">— ไม่ระบุ —</option>
                {PRODUCT_MATERIAL_FORMS.map((form) => (
                  <option key={form} value={form}>
                    {form}
                  </option>
                ))}
              </select>
            ) : (
              <input
                className="cap-input"
                name={field}
                data-testid={`${idPrefix}-${field}`}
                inputMode={field === 'material_spec' ? undefined : 'decimal'}
                value={texts[field]}
                onChange={(event) => onChange(field, event.target.value)}
              />
            )}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
